import { render } from "./ParallaxImage.vue?vue&type=template&id=d8ec91f6"
import script from "./ParallaxImage.vue?vue&type=script&lang=js"
export * from "./ParallaxImage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__